import React from "react";
import { buildGlance } from "./auditGlanceLogic";

// Plain-language summary of the newest audit run: what needs action today, how it changed, which app to look at first.
// Read-only. The detailed tables are behind the "Show detailed tables" button (its state lives in TrackerAuditTab).
const COL = { red: "#f87171", yellow: "#fbbf24", green: "#4ade80", grey: "#7b82a0" };
const BG = { red: "#f8717122", yellow: "#fbbf2422", green: "#4ade8022", grey: "#7b82a022" };
const LABEL = { red: "Fix today", yellow: "Plan to fix", green: "All clear", grey: "Partly checked" };
const ORDER = { red: 0, yellow: 1, green: 2, grey: 3 };

export default function AuditSummary({ run, prevRun, sonar, sonarPrev, showDetail, onToggle }) {
  const g = buildGlance(run, prevRun, sonar, sonarPrev);
  const list = [...g.projects].sort((a, b) => ORDER[a.status] - ORDER[b.status] || (b.reachUsers || 0) - (a.reachUsers || 0));
  const by = (s) => list.filter((p) => p.status === s);
  const red = by("red");
  const s = g.summary;
  let trend = "First run with this data, nothing to compare with yet.";
  if (s.comparedWith && typeof s.seriousAll === "number" && typeof s.seriousAllPrev === "number") {
    const d = s.seriousAll - s.seriousAllPrev;
    trend = d < 0 ? "Since the previous run: " + (-d) + " fewer serious problems (" + s.seriousAll + " in total)."
      : d > 0 ? "Since the previous run: " + d + " more serious problems (" + s.seriousAll + " in total)."
      : "Since the previous run: no change in serious problems (" + s.seriousAll + " in total).";
  }
  const chip = (n, text, st) => (n > 0 ? <span style={{ fontSize: 13, background: BG[st], color: COL[st], padding: "4px 10px", borderRadius: 6 }}>{n + " " + text}</span> : null);
  return (
    <div style={{ margin: "8px 0 12px" }}>
      <div style={{ background: red.length ? BG.red : BG.green, border: "1px solid " + (red.length ? COL.red : COL.green), borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: red.length ? COL.red : COL.green }}>
          {red.length === 0 ? "Nothing urgent today" : red.length === 1 ? "1 app needs action today" : red.length + " apps need action today"}
        </div>
        {red.length > 0 && <div style={{ fontSize: 13, color: COL.red, marginTop: 2 }}>{red.map((p) => p.project).join(", ")}</div>}
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 6 }}>
        {chip(by("yellow").length, "to plan", "yellow")}
        {chip(by("green").length, "all clear", "green")}
        {chip(by("grey").length, "partly checked", "grey")}
      </div>
      <div style={{ fontSize: 13, color: "#8d93ad", marginBottom: 10 }}>{trend}</div>
      <div style={{ background: "#0f111a", border: "1px solid #2a2e45", borderRadius: 10, overflow: "hidden" }}>
        {list.map((p, i) => (
          <div key={p.project} style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "10px 14px", borderTop: i ? "1px solid #23273a" : "none" }}>
            <span style={{ width: 10, height: 10, borderRadius: 5, background: COL[p.status], marginTop: 5, flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: "#e8eaf6", fontWeight: 600, fontSize: 14 }}>{p.project}</div>
              <div style={{ color: "#aab0c8", fontSize: 13, lineHeight: 1.5 }}>{p.sentence}</div>
            </div>
            <span style={{ background: BG[p.status], color: COL[p.status], borderRadius: 6, padding: "2px 10px", fontSize: 12, whiteSpace: "nowrap" }}>{LABEL[p.status]}</span>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 10 }}>
        <button type="button" onClick={onToggle} style={{ background: "#23273a", color: "#e8eaf6", border: "1px solid #2a2e45", borderRadius: 6, padding: "6px 12px", fontSize: 12, cursor: "pointer" }}>
          {showDetail ? "Hide detailed tables" : "Show detailed tables"}
        </button>
      </div>
    </div>
  );
}